import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

let lenis = null;

export const initLenis = (onScrollCallback = null) => {
    lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    if (typeof onScrollCallback === 'function') {
        lenis.on('scroll', (e) => {
            onScrollCallback({
                scroll: e.scroll,
                velocity: e.velocity,
                direction: e.direction,
                progress: e.progress
            });
        });
    }
};

export const scrollTo = (target, options = {}) => {
    lenis?.scrollTo(target, options);
};

export const stopLenis = () => {
    lenis?.stop();
};

export const startLenis = () => {
    lenis?.start();
};

export { lenis };